import BasePropertyView from 'BasePropertyView.js';
import { Model } from 'backbone';
import Immutable from 'immutable';
import _ from 'lodash';

import _template from 'properties/main/mandatory.ejs';
import StageAndRoleSettingsModal from 'common-views/StageAndRoleSettingsModal.js';
import listService from 'ListService.js';
import settingsService from 'MandatoryAndStateSettingsService.js';
import eventBus from 'EventBus.js';
import constants from 'Constants.js';
import textConstants from 'TextConstants.js';
import util from "util/Util";
import undoService from 'UndoService';

class MainMandatoryView extends BasePropertyView {
    get mandatories() {
        return this.model.get('mandatories');
    }
    initialize(opts) {
        this.options = opts || {};
        this.template = _template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=text]': 'updateAttributes',
            'blur input[type=text]': 'lostFocus',
            'focus input[type=text]': 'getFocus',
            'change input[type=checkbox]': 'updateCheckAttributes',
            'click #mandatoryState': 'displayStagesRolesModal'
        };


        // Add needed property

        if (!this.mandatories) {
            if(this.model.get('factoryKey' === 'control_table')){
                _.forEach(this.model.get('gridData'),function(column){
                    if(!column.get('mandatories')){
                        this.model.set('mandatories',new Map(),{silent:true})
                    }
                })
            }
            else{
                this.model.set('mandatories', new Map(), { silent: true });
            }
        }


        if(this.model.get('factoryKey') === 'control_table' && this.model.get('gridData')){
            _.forEach(this.model.get('gridData'),function(elem){
                if(!elem.get('mandatories')) {
                    elem.set('mandatories', new Map(), {silent: true});
                }
            })
        }

        this.listenTo(this.model, 'change', this.render);
        this.listenTo(eventBus, constants.EV_CURRENT_ROLE_OR_STAGE_UPDATED, this.render);
        this.listenTo(this.model, constants.EV_ISMANDATORY_ROLE_OR_STAGE_UPDATED, this.render);

        return this;
    }

    displayStagesRolesModal(ev) {
        ev.preventDefault();
        const alertVIew = new StageAndRoleSettingsModal({ settings: this.model.get('mandatories'), model: this.model });
        alertVIew.render();
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = util.sanitizeHTML(ev.currentTarget.value, true, this.model.get(propName));
        const oldVal = this.model.get(propName);

        if (listService.selectedCount > 1) {
            listService.selected.map(view=>{
                this.model = view.model;
                this.model.set(propName, propVal, constants.MODEL_SILENT);
            });
            if(util.isGroupContainer(this.model.get('factoryKey'))){
                this.render();
                eventBus.trigger('GroupPropertyChange')
            }
            else {
                this.model.trigger('change')
            }
        } else {
            if(util.isGroupContainer(this.model.get('factoryKey'))){
                this.render();
                util.updatePropertyRenderAndSendEvent(propName,propVal,this.model,this.render.bind(this),'GroupPropertyChange')
            }
            else {
                this.model.set(propName,propVal);
            }
        }

        // PF-3465 Undo/Redo for Mandatory.
        undoService.add({
            undo: () =>{
                if (listService.selectedCount > 1) {
                    listService.selected.map(view=>{
                        this.model = view.model;
                        this.model.set(propName, oldVal, constants.MODEL_SILENT);
                    });
                } else {
                    this.model.set(propName, oldVal);
                }
            },
            redo:() => {
                if (listService.selectedCount > 1) {
                    listService.selected.map(view=>{
                        this.model = view.model;
                        this.model.set(propName, propVal, constants.MODEL_SILENT);
                    });
                } else {
                    this.model.set(propName, propVal);
                }
            }
        },textConstants.UNDO_MANDATORY)
    }

    updateCheckAttributes(ev) {
        ev.preventDefault();
        const propVal = ev.currentTarget.checked;
        const oldMandatory = this.mandatories.get(this.getCurrentKey());
        delete this.mandatories[this.getCurrentKey()];
      
        let newValue = "no";
        if (propVal) {
            newValue = "yes";
        }

        const newSetting = settingsService.createSetting(listService.getCurrentStage(), listService.getCurrentRole(), 'required', newValue);
        if (listService.selectedCount > 1) {
            listService.selected.map((view, key)=>{
                this.model = view.model;
                
                if (!this.mandatories) {
                    this.model.set('mandatories', new Map(), constants.MODEL_SILENT);
                }
                
                this.mandatories.set(this.getCurrentKey(), newSetting);
                this.model.trigger(constants.EV_ROLE_AND_STAGE_SETTINGS_UPDATED);
                if(util.isGroupContainer(this.model.get('factoryKey'))){
                    this.render();
                    eventBus.trigger('GroupPropertyChange');
                }
                else {
                    this.model.trigger('change')
                }
            });
            this.render();
        } else {
            this.mandatories.set(this.getCurrentKey(), newSetting);
            this.model.trigger(constants.EV_ROLE_AND_STAGE_SETTINGS_UPDATED);
            if(util.isGroupContainer(this.model.get('factoryKey'))){
                this.render();
                eventBus.trigger('GroupPropertyChange');
            }
            else {
                this.model.trigger('change')
            }
        }

        const currentMandatory = Immutable.Map(this.mandatories);

        // PF-3465 Undo/Redo for Mandatory Checkboxes.
        undoService.add({
            undo: () =>{
                this.model.set('mandatories',oldMandatory,constants.MODEL_SILENT);
                this.model.trigger(constants.EV_ROLE_AND_STAGE_SETTINGS_UPDATED);
                if(util.isGroupContainer(this.model.get('factoryKey'))){
                    this.render();
                    eventBus.trigger('GroupPropertyChange');
                }
                else {
                    this.model.trigger('change')
                }
            },
            redo:() => {
                this.model.set('mandatories',currentMandatory,constants.MODEL_SILENT);
                this.model.trigger(constants.EV_ROLE_AND_STAGE_SETTINGS_UPDATED);
                if(util.isGroupContainer(this.model.get('factoryKey'))){
                    this.render();
                    eventBus.trigger('GroupPropertyChange');
                }
                else {
                    this.model.trigger('change')
                }
            }
        },textConstants.UNDO_MANDATORY_CHECK)
    }

    getCurrentKey() {
        return settingsService.getSettingKey(listService.getCurrentStage(), listService.getCurrentRole());
    }

    mandatorySelected() {
        return settingsService.getSetting({
            stageId: listService.getCurrentStage(),
            roleId: listService.getCurrentRole(),
            settings: this.model.get('mandatories'),
            defaultValue: false,
            settingsField: "required"
        });
    }

    getViewValues() {
        let isMandatory = util.isTrue(this.mandatorySelected());
        return _.merge(this.model.toJSON(), { isMandatory: isMandatory });
    }

    isOnReport() {
        return listService.docType === constants.DOC_TYPE_REPORT
    }

    render() {
        this.$el.empty();
        // This property doesn't be showing on reports
        if (this.template && !this.isOnReport()) {
            //console.log(this.getViewValues());
            this.$el.html(this.template(this.getViewValues()));
        }

        this.addMultilanguageIcon();

        this.delegateEvents();
        return this;
    }

}

export default MainMandatoryView;
